      <div class="setting">
        <div>
          <div class="h7">Dashboard</div>
        <p class="p5">Track data and analytics of your car wash business.</p>
        </div>
        
      </div>
        
        <app-tab-view 
          [tabs]="dashboardTabs" 
          [defaultActiveTab]="activeTab"
          (tabChange)="onTabChange($event)">
          
         
          <div class="tab-content-wrapper">
            
            <div *ngIf=" activeTab === 'Revenue'" class="tab-panel">
              <app-revenue-tab
                [selectedPeriod]="selectedPeriod"
                [selectedPeriodLabel]="selectedPeriodLabel"
                [isDropdownOpen]="isDropdownOpen"
                [periodOptions]="periodOptions"
                [customDateRange]="customDateRange"
                 [selectedLocation]="selectedLocation"
                 [selectedLocationLabel]="selectedLocationLabel"
                 [isLocationDropdownOpen]="isLocationDropdownOpen"
                 [locationOptions]="locationOptions"
                [dashboardStats]="dashboardStats"
                [topSellingService]="topSellingService"
                [revenueByServiceData]="revenueByServiceData"
                [revenueByServiceOptions]="revenueByServiceOptions"
                [revenueTrendData]="revenueTrendData"
                [revenueTrendOptions]="revenueTrendOptions"
                [avgRevenuePerTeamData]="avgRevenuePerTeamData"
                [avgRevenuePerTeamOptions]="avgRevenuePerTeamOptions"
                [isInitialLoad]="isInitialLoad"
                [hasAppliedFilters]="hasAppliedFilters"
                (toggleDropdown)="toggleDropdown()"
                 (selectPeriod)="selectPeriod($event)"
                 (dateRangeApply)="onDateRangeApply($event)"
                 (closePeriodDropdown)="closePeriodDropdown()"
                 (toggleLocationDropdown)="toggleLocationDropdown()"
                 (selectLocation)="selectLocation($event)"
                 [revenueStatsData]="revenueStatsData">
              </app-revenue-tab>
            </div>

            <div *ngIf=" activeTab === 'Customer'" class="tab-panel">
              <app-customer-tab
                [customerDashboardStats]="customerDashboardStats"
                [newVsReturningData]="newVsReturningData"
                [serviceOptinStats]="serviceOptinStats"
                [newVsReturningTrendData]="newVsReturningTrendData"
                [newVsReturningTrendOptions]="newVsReturningTrendOptions"
                [visitFrequencyData]="visitFrequencyData"
                [visitFrequencyOptions]="visitFrequencyOptions"
                [monthlyAcquisitionData]="monthlyAcquisitionData"
                [monthlyAcquisitionOptions]="monthlyAcquisitionOptions"
                [selectedPeriod]="selectedPeriod"
                [selectedPeriodLabel]="selectedPeriodLabel"
                [isDropdownOpen]="isDropdownOpen"
                [periodOptions]="periodOptions"
                [customDateRange]="customDateRange"
                [selectedLocation]="selectedLocation"
                [selectedLocationLabel]="selectedLocationLabel"
                [isLocationDropdownOpen]="isLocationDropdownOpen"
                [locationOptions]="locationOptions"
                (toggleDropdown)="toggleDropdown()"
                [isInitialLoad]="isInitialLoad"
                [hasAppliedFilters]="hasAppliedFilters"
                (selectPeriod)="selectPeriod($event)"
                (dateRangeApply)="onDateRangeApply($event)"
                (closePeriodDropdown)="closePeriodDropdown()"
                (toggleLocationDropdown)="toggleLocationDropdown()"
                (selectLocation)="selectLocation($event)"
                [customerStatsData]="customerStatsData">
              </app-customer-tab>
            </div>

            <div *ngIf=" activeTab === 'Car Wash'" class="tab-panel">
              <app-car-wash-tab
                [selectedCarWashPeriod]="selectedPeriod"
                [selectedPeriodLabel]="selectedPeriodLabel"
                [isCarWashDropdownOpen]="isCarWashDropdownOpen"
                [periodOptions]="periodOptions"
                [customDateRange]="customDateRange"
                [carWashDashboardStats]="carWashDashboardStats"
                [washesByHourData]="washesByHourData"
                [washesByHourOptions]="washesByHourOptions"
                [washesByServiceTypeData]="washesByServiceTypeData"
                [washesByServiceTypeOptions]="washesByServiceTypeOptions"
                [selectedLocation]="selectedLocation"
                [selectedLocationLabel]="selectedLocationLabel"
                [isInitialLoad]="isInitialLoad"
                [hasAppliedFilters]="hasAppliedFilters"
                [isLocationDropdownOpen]="isLocationDropdownOpen"
                [locationOptions]="locationOptions"
                (toggleCarWashDropdown)="toggleCarWashDropdown()"
                (selectCarWashPeriod)="selectCarWashPeriod($event)"
                (dateRangeApply)="onDateRangeApply($event)"
                (closePeriodDropdown)="closePeriodDropdown()"
                (toggleLocationDropdown)="toggleLocationDropdown()"
                (selectLocation)="selectLocation($event)"
                [carWashStatsData]="carWashStatsData">
              </app-car-wash-tab>
            </div>

            <div *ngIf=" activeTab === 'Campaign Management'" class="tab-panel">
              <app-campaign-tab
                [selectedCampaignPeriod]="selectedPeriod"
                [selectedPeriodLabel]="selectedPeriodLabel"
                [isCampaignDropdownOpen]="isCampaignDropdownOpen"
                [campaignDashboardStats]="campaignDashboardStats"
                [campaignBottomStats]="campaignBottomStats"
                [periodOptions]="periodOptions"
                [customDateRange]="customDateRange"
                [selectedCampaignType]="selectedCampaignType"
                [isCampaignTypeDropdownOpen]="isCampaignTypeDropdownOpen"
                [campaignTypeOptions]="platformOptions"
                [selectedCampaignName]="selectedCampaignName"
                [isCampaignNameDropdownOpen]="isCampaignNameDropdownOpen"
                [campaignNameOptions]="campaignNameOptions"
                [campaignPerformanceTrendData]="campaignPerformanceTrendData"
                [campaignPerformanceTrendOptions]="campaignPerformanceTrendOptions"
                [campaignFunnelData]="campaignFunnelData"
                [campaignFunnelOptions]="campaignFunnelOptions"
                [selectedLocation]="selectedLocation"
                [selectedLocationLabel]="selectedLocationLabel"
                [isLocationDropdownOpen]="isLocationDropdownOpen"
                [locationOptions]="locationOptions"
                [isInitialLoad]="isInitialLoad"
                [hasAppliedFilters]="hasAppliedFilters"
                (toggleCampaignDropdown)="toggleCampaignDropdown()"
                (selectCampaignPeriod)="selectCampaignPeriod($event)"
                (dateRangeApply)="onDateRangeApply($event)"
                (closePeriodDropdown)="closePeriodDropdown()"
                (toggleCampaignTypeDropdown)="toggleCampaignTypeDropdown()"
                (selectCampaignType)="selectCampaignType($event)"
                (toggleCampaignNameDropdown)="toggleCampaignNameDropdown()"
                (selectCampaignName)="selectCampaignName($event)"
                (toggleLocationDropdown)="toggleLocationDropdown()"
                (selectLocation)="selectLocation($event)">
              </app-campaign-tab>
            </div>
            
          </div>
          
        </app-tab-view>
      

